import type { ColumnConfig, ConfigTableProps } from '@/components/datatable/dataTableTypes';
import { createContractActionStatusPrefilterTab, type PrefilterTab } from '@/utils/prefilter';

import type { ContractActionSimple } from '../contractActionTypes';

export const columns: ColumnConfig[] = [
  { field: 'id', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'type', type: 'enum' },
  { field: 'actingBy', type: 'enum' },
  { field: 'maxCount', type: 'number', hideInitial: true },
  { field: 'numberOfUses', type: 'number', hideInitial: true },
  { field: 'combinedCount' },
  {
    field: 'combinedExtensionValue',
    combinedField: ['extensionValue', 'extensionUnit'],
    template: 'concatString',
  },
  { field: 'extensionValue', type: 'number', align: 'center', hidden: true },
  { field: 'extensionUnit', type: 'enum', hidden: true },
  { field: 'noticePeriod', type: 'string', hidden: true },
  { field: 'noticePeriodUnit', type: 'enum', hidden: true },
  {
    field: 'combinedNoticePeriod',
    combinedField: ['noticePeriod', 'noticePeriodUnit'],
    template: 'concatString',
  },
  { field: 'resiliationDate', type: 'date', align: 'center' },
  { field: 'status', type: 'enum' },
  { field: 'statusActions' },
  { field: 'contractId', truncateLength: 8, noWrap: true, hideInitial: true },
  { field: 'version', hideInitial: true, align: 'center' },
  { field: 'comment', truncateLength: 50, type: 'string', hideInitial: true },
];

export const tableConfig: ConfigTableProps = {
  reorderableRows: true,
};

export function createStatusPrefilterTab(data: ContractActionSimple[]): PrefilterTab[] {
  return [
    {
      title: 'labels.tabsAll',
      isClearFilterTab: true,
      options: [
        {
          title: 'labels.tabsAll',
          initialActive: true,
          customFilterFn: (data) => data,
        },
      ],
    },
    createContractActionStatusPrefilterTab(data),
  ];
}
